var _circle, _circle2, _circle3, _g, _path, _g2, _path2, _g3, _path3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _path8, _path9, _path10, _g7, _path11, _path12, _g8, _path13, _path14, _g9, _g10, _g11, _path15, _path16, _path17, _g12, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewYield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 444,
    viewBox: "0 0 660 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_5757)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 222,
    r: 204.5,
    stroke: "#2C2E3A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 222,
    r: 273.5,
    stroke: "#2C2E3A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 222,
    r: 126.5,
    stroke: "#2C2E3A"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 246,
    y: 138,
    width: 168,
    height: 168
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_1_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_95_5757)",
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 222,
    r: 74,
    fill: "#F4234D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.381 211.24H293.701C293.701 212.92 294.741 213.56 296.101 213.56C297.701 213.56 298.421 212.84 298.421 211.88C298.421 211.16 297.941 210.44 295.861 210.44C292.501 210.44 291.541 209.16 291.541 207.64C291.541 205.8 293.061 204.36 296.101 204.36C299.781 204.36 300.501 206.28 300.501 207.8H298.181C298.181 206.84 297.621 206.04 296.021 206.04C294.501 206.04 293.941 206.76 293.941 207.48C293.941 208.2 294.661 208.68 296.341 208.68C299.541 208.68 300.821 209.8 300.821 211.64C300.821 213.96 298.901 215.24 296.101 215.24C292.821 215.24 291.381 213.64 291.381 211.24ZM300.976 208.6V207H302.576V204.6H304.656V207H306.416V208.6H304.656V212.68C304.656 213.4 304.896 213.56 305.456 213.56C305.776 213.56 306.416 213.48 306.416 213.48V215C306.416 215 305.376 215.16 304.656 215.16C302.976 215.16 302.576 214.6 302.576 212.68V208.6H300.976ZM309.373 215H307.293V207H309.373V209.144C309.405 209.032 310.221 206.84 312.093 206.84H312.333V209H311.773C310.653 209 309.373 209.64 309.373 211.72V215ZM318.736 207H320.816V215H318.736V213.48C318.736 213.48 317.616 215.24 315.856 215.24C313.936 215.24 313.136 214.04 313.136 212.28V207H315.216V211.72C315.216 213.08 315.776 213.56 316.736 213.56C317.696 213.56 318.736 212.84 318.736 211V207ZM323.777 211C323.777 213.16 324.737 213.8 325.777 213.8C326.737 213.8 327.457 213.16 327.537 211.96H329.697C329.617 213.72 328.417 215.24 325.777 215.24C322.977 215.24 321.617 213.32 321.617 211C321.617 208.68 322.977 206.76 325.777 206.76C328.417 206.76 329.617 208.28 329.697 210.04H327.537C327.457 208.84 326.737 208.2 325.777 208.2C324.737 208.2 323.777 208.84 323.777 211ZM329.851 208.6V207H331.451V204.6H333.531V207H335.291V208.6H333.531V212.68C333.531 213.4 333.771 213.56 334.331 213.56C334.651 213.56 335.291 213.48 335.291 213.48V215C335.291 215 334.251 215.16 333.531 215.16C331.851 215.16 331.451 214.6 331.451 212.68V208.6H329.851ZM341.768 207H343.848V215H341.768V213.48C341.768 213.48 340.648 215.24 338.888 215.24C336.968 215.24 336.168 214.04 336.168 212.28V207H338.248V211.72C338.248 213.08 338.808 213.56 339.768 213.56C340.728 213.56 341.768 212.84 341.768 211V207ZM346.888 215H344.808V207H346.888V209.144C346.92 209.032 347.736 206.84 349.608 206.84H349.848V209H349.288C348.168 209 346.888 209.64 346.888 211.72V215ZM358.338 211.4H352.434C352.53 213.176 353.378 213.8 354.498 213.8C355.458 213.8 356.018 213.16 356.178 212.36H358.258C357.938 213.88 356.898 215.24 354.418 215.24C351.618 215.24 350.258 213.32 350.258 211C350.258 208.68 351.618 206.76 354.418 206.76C356.898 206.76 358.338 208.36 358.338 210.76V211.4ZM354.418 208.2C353.554 208.2 352.738 208.648 352.482 210.04H356.178C356.098 208.76 355.378 208.2 354.418 208.2ZM365.296 204.6H367.376V215H365.296V213.64C365.296 213.64 364.496 215.24 362.576 215.24C360.656 215.24 358.976 213.88 358.976 211C358.976 208.12 360.656 206.76 362.576 206.76C364.496 206.76 365.296 208.2 365.296 208.2V204.6ZM361.136 211C361.136 213 362.176 213.8 363.216 213.8C364.256 213.8 365.296 213 365.296 211C365.296 209 364.256 208.2 363.216 208.2C362.176 208.2 361.136 209 361.136 211ZM301.824 239V228.6H306.784C309.024 228.6 310.624 229.48 310.624 231.72C310.624 233.96 309.024 234.84 306.784 234.84H303.984V239H301.824ZM303.984 230.36V233.08H306.784C307.664 233.08 308.224 232.6 308.224 231.72C308.224 230.84 307.664 230.36 306.784 230.36H303.984ZM313.419 239H311.339V231H313.419V233.144C313.451 233.032 314.267 230.84 316.139 230.84H316.379V233H315.819C314.699 233 313.419 233.64 313.419 235.72V239ZM316.789 235C316.789 232.68 318.069 230.76 320.949 230.76C323.829 230.76 325.109 232.68 325.109 235C325.109 237.32 323.829 239.24 320.949 239.24C318.069 239.24 316.789 237.32 316.789 235ZM318.949 235C318.949 237.08 319.909 237.8 320.949 237.8C321.989 237.8 322.949 237.08 322.949 235C322.949 232.92 321.989 232.2 320.949 232.2C319.909 232.2 318.949 232.92 318.949 235ZM332.062 228.6H334.142V239H332.062V237.64C332.062 237.64 331.262 239.24 329.342 239.24C327.422 239.24 325.742 237.88 325.742 235C325.742 232.12 327.422 230.76 329.342 230.76C331.262 230.76 332.062 232.2 332.062 232.2V228.6ZM327.902 235C327.902 237 328.942 237.8 329.982 237.8C331.022 237.8 332.062 237 332.062 235C332.062 233 331.022 232.2 329.982 232.2C328.942 232.2 327.902 233 327.902 235ZM340.705 231H342.785V239H340.705V237.48C340.705 237.48 339.585 239.24 337.825 239.24C335.905 239.24 335.105 238.04 335.105 236.28V231H337.185V235.72C337.185 237.08 337.745 237.56 338.705 237.56C339.665 237.56 340.705 236.84 340.705 235V231ZM345.746 235C345.746 237.16 346.706 237.8 347.746 237.8C348.706 237.8 349.426 237.16 349.506 235.96H351.666C351.586 237.72 350.386 239.24 347.746 239.24C344.946 239.24 343.586 237.32 343.586 235C343.586 232.68 344.946 230.76 347.746 230.76C350.386 230.76 351.586 232.28 351.666 234.04H349.506C349.426 232.84 348.706 232.2 347.746 232.2C346.706 232.2 345.746 232.84 345.746 235ZM351.82 232.6V231H353.42V228.6H355.5V231H357.26V232.6H355.5V236.68C355.5 237.4 355.74 237.56 356.3 237.56C356.62 237.56 357.26 237.48 357.26 237.48V239C357.26 239 356.22 239.16 355.5 239.16C353.82 239.16 353.42 238.6 353.42 236.68V232.6H351.82Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 285,
    y: 305,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_2_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 349,
    r: 24,
    fill: "url(#paint0_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.265 350.384C337.531 350.977 339.752 352.143 339.752 353.485C339.752 355.427 335.106 357 329.376 357C323.646 357 319 355.427 319 353.485C319 352.143 321.222 350.977 324.487 350.384C325.906 350.747 327.582 350.955 329.376 350.955C331.17 350.955 332.846 350.746 334.265 350.384ZM333.015 344.692C335.789 345.146 337.699 346.1 337.699 347.206C337.699 348.749 333.973 350 329.376 350C324.779 350 321.053 348.749 321.053 347.206C321.053 346.101 322.964 345.146 325.738 344.692C326.804 344.958 328.047 345.11 329.376 345.11C330.705 345.11 331.948 344.957 333.015 344.692ZM329.414 340C332.856 340 335.648 340.947 335.648 342.116C335.648 343.284 332.856 344.23 329.414 344.23C325.972 344.23 323.181 343.284 323.181 342.116C323.181 340.947 325.972 340 329.414 340Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 144,
    y: 327,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_3_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 371,
    r: 24,
    fill: "url(#paint1_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.004 359L193.662 367.524L188.004 370.695L182.346 367.524L188.004 359ZM184.076 367.119L188.004 361.205L191.931 367.119L188.004 369.319L184.076 367.119Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.998 372.569L181.434 368.89L181.257 369.158C179.238 372.203 179.688 376.189 182.34 378.746C185.463 381.751 190.529 381.751 193.656 378.746C196.313 376.189 196.763 372.203 194.739 369.158L194.562 368.89L187.998 372.569Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 12,
    y: 178,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_4_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 222,
    r: 24,
    fill: "url(#paint2_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2748 213L56.3835 213C51.6814 213 47.8696 216.921 47.8696 221.757L47.8696 224.055C47.8696 224.114 47.9161 224.162 47.9734 224.162H49.1614C49.2188 224.162 49.2653 224.114 49.2653 224.055L49.2653 221.757C49.2653 217.714 52.4523 214.436 56.3835 214.436L64.3347 214.436C64.4142 214.436 64.4639 214.348 64.4216 214.278C63.9691 213.538 63.2914 213.001 62.2766 213H62.2748ZM65.1783 216.534C65.1699 216.483 65.1268 216.446 65.0764 216.446L56.3838 216.446C53.4546 216.446 51.08 218.888 51.08 221.901L51.08 224.055C51.08 224.114 51.1265 224.162 51.1839 224.162H52.0602C52.2897 224.162 52.4757 223.971 52.4757 223.735V221.901C52.4757 219.681 54.2254 217.881 56.3838 217.881H65.2079C65.2672 217.881 65.3145 217.83 65.3111 217.769C65.2918 217.423 65.2537 216.993 65.1783 216.534ZM46.2349 227.554C46.1845 227.554 46.1414 227.517 46.133 227.466C46.0576 227.007 46.0195 226.577 46.0002 226.231C45.9968 226.17 46.0441 226.119 46.1034 226.119H54.9275C57.0859 226.119 58.8355 224.319 58.8355 222.099V220.265C58.8355 220.029 59.0216 219.838 59.2511 219.838H60.1274C60.1848 219.838 60.2313 219.886 60.2313 219.945V222.099C60.2313 225.112 57.8567 227.554 54.9275 227.554H46.2349ZM54.9278 231H49.0365H49.0347C48.0198 230.999 47.3422 230.462 46.8897 229.722C46.8474 229.652 46.8971 229.564 46.9766 229.564H54.9278C58.859 229.564 62.046 226.286 62.046 222.243V219.945C62.046 219.886 62.0925 219.838 62.1499 219.838H63.3379C63.3952 219.838 63.4417 219.886 63.4417 219.945V222.243C63.4417 227.079 59.6299 231 54.9278 231Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 162,
    y: 178,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_5_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 222,
    r: 24,
    fill: "url(#paint3_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.126 222C195.126 215.925 200.051 211 206.126 211C212.201 211 217.126 215.925 217.126 222C217.126 224.152 216.508 226.159 215.44 227.854C215.146 228.321 214.818 228.764 214.458 229.181L206.14 220.863L198.988 228.015L197.807 229.196C197.446 228.781 197.117 228.338 196.823 227.871C195.748 226.173 195.126 224.159 195.126 222ZM214.179 226.287L214.28 226.086L214.28 226.086C214.911 224.827 215.245 223.414 215.245 222C215.245 216.973 211.154 212.882 206.126 212.882C201.098 212.882 197.008 216.973 197.008 222C197.008 223.422 197.345 224.841 197.982 226.104L198.083 226.305L206.14 218.248L214.179 226.287ZM206.126 233C208.865 233 211.37 231.999 213.296 230.343V230.343L206.141 223.188L198.972 230.356C200.895 232.005 203.388 233 206.126 233Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 413,
    y: 178,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_6_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 457,
    cy: 222,
    r: 24,
    fill: "url(#paint4_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.151 230.605C453.721 230.605 450.8 228.418 449.686 225.352C450.925 228.273 453.978 230.37 457.151 230.37C460.323 230.37 463.399 228.297 464.615 225.352C463.502 228.418 460.58 230.605 457.151 230.605ZM464.81 219.579C464.44 218.677 464.821 217.651 465.663 217.207C464.874 215.98 463.85 214.966 462.678 214.2C462.354 214.824 461.718 215.196 461.049 215.201C462.6 216.61 464.711 218.92 464.711 222.385C464.711 226.591 461.326 230.001 457.151 230.001C452.975 230.001 449.59 226.591 449.59 222.385C449.59 218.92 451.701 216.61 453.253 215.201C452.583 215.196 451.947 214.823 451.623 214.2C450.405 214.994 449.399 216.026 448.639 217.207C449.481 217.651 449.861 218.677 449.491 219.579C449.12 220.48 448.131 220.934 447.224 220.649C446.932 222.025 446.919 223.472 447.223 224.901C448.13 224.615 449.12 225.069 449.491 225.971C449.861 226.873 449.48 227.899 448.638 228.343C449.427 229.57 450.451 230.584 451.623 231.349C452.064 230.501 453.083 230.118 453.978 230.491C454.873 230.864 455.323 231.861 455.04 232.775C456.406 233.069 457.843 233.081 459.261 232.776C458.977 231.862 459.428 230.865 460.323 230.491C461.219 230.117 462.237 230.502 462.678 231.35C463.896 230.555 464.903 229.524 465.662 228.343C464.821 227.899 464.44 226.872 464.81 225.971C465.181 225.07 466.171 224.615 467.077 224.901C467.369 223.525 467.382 222.078 467.078 220.649C466.171 220.935 465.181 220.48 464.81 219.579Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.331 212.087C453.302 213.84 453.922 215.138 454.301 216.464C455.731 221.466 449.894 222.733 452.163 217.437C451.265 218.86 450.469 219.946 450.469 222.432C450.469 224.951 451.842 227.146 453.875 228.3C453.417 225.539 455.958 225.092 457.15 223.001C459.313 219.207 453.282 215.906 454.331 212.087Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.94 214.299C457.154 212.351 455.664 210.462 457.549 207C456.269 208.156 453.819 212.55 455.855 215.474C457.661 218.068 459.216 220.285 458.267 222.904C457.429 225.216 454.308 226.315 455.089 228.836C459.362 230.231 463.832 227.032 463.832 222.432C463.832 218.274 459.833 215.273 458.94 214.299Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.795 208.832C456.952 211.705 458.22 212.418 460.773 214.929C461.017 212.674 457.982 211.415 459.795 208.832Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 435,
    y: 34,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_7_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 78,
    r: 24,
    fill: "url(#paint5_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M479 67H479C472.925 67 468 71.9248 468 77.9998V78.0002C468 84.0753 472.925 89 479 89H479C485.075 89 490 84.0753 490 78.0002V77.9998C490 71.9248 485.075 67 479 67Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.594 72.884H476.359L476.207 73.0625L472.284 77.6707L472.004 77.9997L472.284 78.3286L476.207 82.9368L476.359 83.1153H476.594H483.657H484.164V82.6079V79.6783H483.149V82.1004H477.703L480.963 78.3316L481.25 77.9997L480.963 77.6677L477.703 73.8989H483.149V76.321H484.164V73.3915V72.884H483.657H476.594ZM476.597 74.1707L473.337 77.9997L476.597 81.8286L479.908 77.9997L476.597 74.1707Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 144,
    y: 34,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_8_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 78,
    r: 24,
    fill: "url(#paint6_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.992 78.5944C187.886 76.5555 187.109 74.4813 186.354 72.7843C186.178 72.3836 186.119 71.1226 187.662 71.3936C189.572 72.0654 194.533 73.9864 194.804 76.3905C194.91 77.3569 194.227 78.0405 192.471 78.2762C190.715 78.5001 188.806 78.559 187.992 78.5944ZM187.992 78.5944C188.099 80.6332 187.992 82.3656 187.462 84.3455M187.462 84.3337C186.955 86.9972 185.376 88.4232 184.139 88.7767C177.798 90.5798 177.539 81.0221 178.223 75.9309C178.635 72.8314 180.12 69.8027 181.935 68.6713C182.689 68.1999 184.327 67.587 186.908 68.3884C190.055 69.3784 193.249 71.0637 194.085 71.5586C194.922 72.0536 196.902 73.5739 197.538 74.4813C198.764 76.2373 199.259 77.1212 198.67 79.3368C198.092 81.5642 195.877 81.8942 195.17 82.012C192.094 82.5777 190.432 83.3202 187.462 84.3337Z",
    stroke: "white",
    strokeWidth: 1.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.198 81.4936C184.221 82.4011 184.044 83.1907 183.773 83.7328C183.49 84.2985 183.196 84.4163 183.054 84.4281C182.913 84.4281 182.618 84.3338 182.3 83.7799C181.994 83.2614 181.77 82.4836 181.746 81.5761C181.723 80.6686 181.899 79.879 182.171 79.3369C182.453 78.7712 182.748 78.6534 182.889 78.6416C183.031 78.6416 183.325 78.7359 183.644 79.2898C183.938 79.8083 184.162 80.5861 184.198 81.4936Z",
    stroke: "white",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 435,
    y: 327,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_9_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 371,
    r: 24,
    fill: "url(#paint7_linear_95_5757)",
    fillOpacity: 0.6
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_95_5757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.049 361.533C474.775 361.49 474.763 361.486 474.892 361.466C475.139 361.428 475.722 361.48 476.124 361.575C477.063 361.797 477.917 362.365 478.829 363.374L479.071 363.643L479.417 363.587C480.877 363.354 482.362 363.539 483.603 364.11C483.945 364.267 484.484 364.579 484.551 364.66C484.572 364.685 484.612 364.85 484.639 365.026C484.731 365.634 484.685 366.1 484.498 366.448C484.396 366.638 484.39 366.698 484.459 366.86C484.513 366.989 484.665 367.085 484.816 367.085C485.125 367.084 485.457 366.588 485.611 365.898L485.672 365.624L485.793 365.76C486.458 366.509 486.979 367.53 487.069 368.256L487.092 368.446L486.981 368.273C486.788 367.977 486.595 367.775 486.348 367.613C485.902 367.319 485.431 367.219 484.183 367.154C483.056 367.095 482.418 366.999 481.785 366.794C480.709 366.445 480.166 365.98 478.888 364.312C478.32 363.571 477.969 363.161 477.619 362.83C476.826 362.08 476.047 361.687 475.049 361.533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.806 363.187C484.834 362.691 484.902 362.363 485.038 362.064C485.092 361.946 485.142 361.849 485.15 361.849C485.158 361.849 485.135 361.936 485.098 362.043C484.999 362.333 484.983 362.73 485.051 363.192C485.138 363.779 485.187 363.863 485.81 364.496C486.102 364.793 486.442 365.168 486.565 365.329L486.789 365.621L486.565 365.412C486.291 365.156 485.661 364.658 485.522 364.587C485.428 364.539 485.415 364.54 485.357 364.597C485.304 364.649 485.293 364.728 485.285 365.101C485.274 365.682 485.194 366.056 485.002 366.429C484.898 366.63 484.882 366.587 484.976 366.36C485.046 366.19 485.053 366.115 485.053 365.552C485.052 364.422 484.917 364.15 484.125 363.684C483.925 363.566 483.594 363.396 483.391 363.306C483.188 363.216 483.027 363.138 483.032 363.132C483.055 363.11 483.827 363.334 484.137 363.453C484.599 363.629 484.676 363.652 484.732 363.631C484.769 363.617 484.788 363.508 484.806 363.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.581 365.121C475.025 364.36 474.681 363.192 474.755 362.319L474.778 362.049L474.905 362.072C475.143 362.115 475.552 362.267 475.744 362.383C476.271 362.701 476.499 363.12 476.731 364.196C476.799 364.511 476.888 364.867 476.929 364.988C476.995 365.182 477.245 365.636 477.448 365.931C477.594 366.143 477.497 366.244 477.174 366.215C476.68 366.171 476.012 365.712 475.581 365.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.131 370.789C481.532 369.749 480.616 368.845 480.616 367.321C480.616 367.096 480.624 366.913 480.634 366.913C480.643 366.913 480.744 366.987 480.857 367.077C481.384 367.498 481.974 367.677 483.608 367.914C484.57 368.054 485.111 368.167 485.61 368.331C487.196 368.855 488.178 369.916 488.412 371.363C488.48 371.783 488.44 372.571 488.329 372.987C488.242 373.315 487.977 373.906 487.906 373.929C487.887 373.935 487.868 373.861 487.863 373.759C487.836 373.216 487.56 372.687 487.097 372.291C486.57 371.841 485.862 371.483 484.131 370.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.306 371.222C482.273 371.029 482.217 370.783 482.181 370.675L482.114 370.478L482.237 370.616C482.408 370.806 482.543 371.05 482.657 371.374C482.744 371.622 482.754 371.695 482.753 372.097C482.752 372.492 482.741 372.575 482.661 372.798C482.534 373.149 482.377 373.398 482.112 373.666C481.638 374.146 481.027 374.412 480.146 374.523C479.993 374.542 479.547 374.574 479.155 374.595C478.166 374.646 477.515 374.751 476.93 374.956C476.846 374.985 476.771 375.003 476.764 374.995C476.74 374.972 477.138 374.736 477.467 374.578C477.931 374.356 478.392 374.235 479.426 374.064C479.937 373.979 480.465 373.876 480.599 373.835C481.864 373.45 482.514 372.454 482.306 371.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.498 373.326C483.152 372.588 483.073 371.875 483.262 371.21C483.283 371.139 483.315 371.081 483.335 371.081C483.354 371.081 483.436 371.125 483.516 371.178C483.675 371.285 483.994 371.464 484.844 371.925C485.905 372.501 486.51 372.946 486.922 373.455C487.282 373.901 487.505 374.409 487.612 375.028C487.673 375.379 487.637 376.222 487.547 376.576C487.262 377.689 486.599 378.564 485.653 379.074C485.514 379.149 485.39 379.21 485.377 379.21C485.363 379.211 485.414 379.083 485.489 378.927C485.807 378.265 485.843 377.622 485.603 376.906C485.455 376.467 485.155 375.932 484.549 375.028C483.844 373.977 483.671 373.697 483.498 373.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.735 377.31C474.7 376.5 475.9 375.925 476.993 375.748C477.464 375.672 478.249 375.702 478.685 375.813C479.385 375.991 480.01 376.39 480.336 376.865C480.653 377.329 480.79 377.734 480.932 378.634C480.988 378.989 481.049 379.345 481.067 379.426C481.174 379.892 481.381 380.265 481.639 380.453C482.047 380.75 482.751 380.768 483.442 380.5C483.56 380.454 483.662 380.423 483.669 380.43C483.694 380.455 483.346 380.687 483.1 380.809C482.769 380.973 482.506 381.037 482.157 381.037C481.523 381.037 480.997 380.716 480.558 380.062C480.471 379.934 480.277 379.548 480.126 379.206C479.663 378.154 479.434 377.834 478.896 377.483C478.427 377.178 477.823 377.124 477.369 377.345C476.772 377.636 476.605 378.395 477.033 378.876C477.203 379.067 477.52 379.232 477.779 379.264C478.263 379.324 478.68 378.957 478.68 378.47C478.68 378.154 478.558 377.974 478.25 377.836C477.83 377.647 477.379 377.868 477.381 378.26C477.382 378.427 477.455 378.532 477.624 378.608C477.732 378.657 477.735 378.661 477.647 378.643C477.261 378.563 477.171 378.101 477.481 377.794C477.853 377.426 478.622 377.589 478.886 378.091C478.997 378.302 479.01 378.723 478.913 378.977C478.697 379.545 478.065 379.844 477.425 379.681C476.989 379.57 476.811 379.451 476.286 378.912C475.372 377.976 475.018 377.795 473.701 377.59L473.448 377.551L473.735 377.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.449 360.56C472.5 364.242 474.601 365.762 474.834 366.083C475.027 366.348 474.955 366.586 474.624 366.773C474.441 366.877 474.063 366.982 473.874 366.982C473.66 366.982 473.587 366.9 473.587 366.9C473.463 366.783 473.393 366.803 472.756 365.679C471.872 364.315 471.133 363.183 471.112 363.164C471.066 363.121 471.067 363.122 472.666 365.969C472.925 366.562 472.718 366.78 472.718 366.864C472.718 367.036 472.67 367.126 472.457 367.363C472.102 367.757 471.943 368.2 471.828 369.118C471.7 370.146 471.338 370.872 470.336 372.115C469.75 372.842 469.654 372.975 469.506 373.269C469.319 373.638 469.268 373.845 469.247 374.311C469.225 374.804 469.268 375.122 469.419 375.594C469.552 376.007 469.69 376.279 470.044 376.824C470.35 377.294 470.525 377.644 470.525 377.781C470.525 377.889 470.546 377.889 471.019 377.783C472.152 377.529 473.071 377.082 473.588 376.534C473.908 376.194 473.983 376.007 473.985 375.542C473.987 375.238 473.976 375.175 473.894 375C473.759 374.715 473.514 374.478 472.974 374.111C472.267 373.63 471.965 373.243 471.882 372.711C471.813 372.274 471.893 371.966 472.284 371.15C472.689 370.306 472.789 369.946 472.857 369.095C472.901 368.545 472.962 368.328 473.121 368.154C473.286 367.973 473.435 367.912 473.845 367.856C474.513 367.765 474.939 367.593 475.289 367.272C475.592 366.994 475.719 366.726 475.739 366.323L475.753 366.017L475.584 365.821C474.97 365.108 469.038 360 469 360C468.992 360 469.194 360.252 469.449 360.56ZM470.87 374.869C471.009 374.624 470.935 374.31 470.703 374.156C470.483 374.011 470.143 374.079 470.143 374.269C470.143 374.326 470.175 374.368 470.247 374.405C470.369 374.468 470.378 374.538 470.282 374.681C470.185 374.826 470.193 374.953 470.304 375.04C470.483 375.18 470.737 375.103 470.87 374.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.176 368.016C475.862 368.112 475.557 368.443 475.462 368.79C475.405 369.001 475.438 369.372 475.524 369.487C475.663 369.672 475.798 369.721 476.163 369.718C476.877 369.713 477.498 369.408 477.571 369.027C477.63 368.715 477.357 368.282 476.981 368.092C476.787 367.994 476.375 367.955 476.176 368.016ZM477.011 368.666C477.121 368.51 477.073 368.342 476.885 368.228C476.529 368.011 475.989 368.191 475.989 368.526C475.989 368.693 476.27 368.875 476.528 368.875C476.7 368.875 476.935 368.773 477.011 368.666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 285,
    y: 54,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_11_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 98,
    r: 24,
    fill: "url(#paint8_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M329 90.6001C322.372 90.6001 316.998 96.1998 317 103.105H320.066C320.066 97.9302 324.034 93.7344 329 93.7344C333.966 93.7344 337.934 97.9302 337.934 103.105H341C341.001 96.1998 335.627 90.6001 329 90.6001Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M325.814 103.4C327.161 103.4 328.254 102.283 328.254 100.906C328.254 99.5281 327.161 98.4114 325.814 98.4114C324.467 98.4114 323.375 99.5281 323.375 100.906C323.375 102.283 324.467 103.4 325.814 103.4Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.189 103.4C333.536 103.4 334.629 102.283 334.629 100.906C334.629 99.5281 333.536 98.4114 332.189 98.4114C330.842 98.4114 329.75 99.5281 329.75 100.906C329.75 102.283 330.842 103.4 332.189 103.4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 560,
    y: 178,
    width: 88,
    height: 88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_12_95_5757_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_95_5757)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 222,
    r: 24,
    fill: "url(#paint9_linear_95_5757)",
    fillOpacity: 0.6
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M604.786 229.571C609.638 229.571 613.571 225.638 613.571 220.786C613.571 215.933 609.638 212 604.786 212C599.933 212 596 215.933 596 220.786C596 225.638 599.933 229.571 604.786 229.571Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M601.379 224.327C603.791 224.598 605.667 226.645 605.667 229.129C605.667 231.799 603.502 233.962 600.833 233.962C598.164 233.962 596 231.799 596 229.129C596 226.64 597.882 224.589 600.302 224.325V213.228C600.646 213.023 601.006 212.841 601.379 212.684V224.327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_95_5757",
    x: 246,
    y: 138,
    width: 168,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_95_5757_clip_path",
    transform: "translate(-246 -138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 222,
    r: 74
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_95_5757",
    x: 285,
    y: 305,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_95_5757_clip_path",
    transform: "translate(-285 -305)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 349,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_95_5757",
    x: 144,
    y: 327,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_95_5757_clip_path",
    transform: "translate(-144 -327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 371,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_95_5757",
    x: 12,
    y: 178,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_95_5757_clip_path",
    transform: "translate(-12 -178)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 222,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_95_5757",
    x: 162,
    y: 178,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_5_95_5757_clip_path",
    transform: "translate(-162 -178)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 222,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_95_5757",
    x: 413,
    y: 178,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_6_95_5757_clip_path",
    transform: "translate(-413 -178)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 457,
    cy: 222,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_95_5757",
    x: 435,
    y: 34,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_7_95_5757_clip_path",
    transform: "translate(-435 -34)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 78,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_95_5757",
    x: 144,
    y: 34,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_8_95_5757_clip_path",
    transform: "translate(-144 -34)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 78,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_95_5757",
    x: 435,
    y: 327,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_9_95_5757_clip_path",
    transform: "translate(-435 -327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 371,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_95_5757",
    x: 285,
    y: 54,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_11_95_5757_clip_path",
    transform: "translate(-285 -54)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 98,
    r: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_95_5757",
    x: 560,
    y: 178,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_12_95_5757_clip_path",
    transform: "translate(-560 -178)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 222,
    r: 24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_5757",
    x1: 329,
    y1: 325,
    x2: 329,
    y2: 373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_5757",
    x1: 188,
    y1: 347,
    x2: 188,
    y2: 395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_5757",
    x1: 56,
    y1: 198,
    x2: 56,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_5757",
    x1: 206,
    y1: 198,
    x2: 206,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_5757",
    x1: 457,
    y1: 198,
    x2: 457,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_95_5757",
    x1: 479,
    y1: 54,
    x2: 479,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_95_5757",
    x1: 188,
    y1: 54,
    x2: 188,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_95_5757",
    x1: 479,
    y1: 347,
    x2: 479,
    y2: 395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_95_5757",
    x1: 329,
    y1: 74,
    x2: 329,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_95_5757",
    x1: 604,
    y1: 198,
    x2: 604,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_5757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 660,
    height: 444,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_95_5757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white",
    transform: "translate(469 360)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewYield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new_yield.87d7edef07a629110abd8fc556868867.svg";